export default __webpack_public_path__ + "static/media/k_series_statistig_grouop_id.e03d0f74.jpg";